/**
 * @ INTERNAL DEPENDENCIES
 */
import { handleActions } from "redux-actions";
/**
 * @ ACTIONS
 */
import {
  setIsAuthenticated,
  setIsNotAuthenticated,
  _setStores,
  setForceAccountMaintMode,
  setUser,
  setIsSessionTimeout,
  setErrorOverlay,
  scrollToTop,
  setActiveStore,
  _updateActiveStoreData,
  manageableSellers,
} from "./actions";

import moment from "moment";
import {setStoreIdHeader} from "../../api";

/**
 * @ REDUCER
 */
const defaultState = {
  user: {},
  email: null,
  name: "",
  isAuthenticated: false,
  isGlobalAdmin:false,
  accountMaintMode: null,
  stores: [],
  permissions: [],
  classes: [],
  notificationMuted: false,
  sidebarActive: false,
  avatar: "",
  isSessionTimeout: false,
  error: null,
  scrollToTopClock: moment(),
  activeStore: null,
  activeStoreObject: null,
  hasUserManagementPermissions: false,
};

const app = handleActions(
  {
    [setForceAccountMaintMode]: (state, { payload }) => ({
      ...state,
      accountMaintMode: payload,
    }),
    [setActiveStore]: (state, { payload }) => {
      setStoreIdHeader(payload)
      let activeStoreObject = {}
      for (let i = 0; i < state.stores.length; i++) {
        if(state.stores[i].id === payload || state.stores[i].store_id === payload){
          activeStoreObject = state.stores[i];
          break
        }
      }
      return {
        ...state,
        activeStore: payload,
        activeStoreObject
      };
    },
    [scrollToTop]: (state, {}) => ({ ...state, scrollToTopClock: moment() }),
    [setErrorOverlay]: (state, { payload }) => ({ ...state, error: payload }),
    [setIsSessionTimeout]: (state, { payload }) => {
      if (payload) {
        if (window.sessionTimeoutTimer) {
          window.clearTimeout(window.sessionTimeoutTimer);
        }
      }
      return {
        ...state,
        isSessionTimeout: payload,
      };
    },
    [setUser]: (state, { payload }) => {
      
      let hasUserManagementPermissions = false, isGlobalAdmin = false;
      let manageableSellers = [];
      for (let i = 0; i < (payload.permissions || []).length; i++) {
        manageableSellers.push(payload.permissions[i].seller);
        if (
          payload.permissions[i].permissions.includes("user_management") ||
          payload.permissions[i].permissions.includes("*")
        ) {
          hasUserManagementPermissions = true;
          break; // Only need to have user management permission in one location to show the user management screen
        }
      }
      if(payload.type === 'saucey_admin'){
        isGlobalAdmin = true;
        hasUserManagementPermissions = true;

      }
      return {
        ...state,
        user: payload,
        isGlobalAdmin,
        hasUserManagementPermissions,
        manageableSellers,
      };
    },
    [_setStores]: (state, { payload }) => ({
      ...state,
      stores: payload,
    }),
    [_updateActiveStoreData]: (state, {payload}) => ({
      ...state,
      activeStoreObject:payload
    }),
    [setIsAuthenticated]: (state) => ({
      ...state,
      isAuthenticated: true,
    }),
    [setIsNotAuthenticated]: (state) => ({
      ...state,
      isAuthenticated: false,
    }),
  },
  defaultState
);

export default app;
